module.exports = __webpack_public_path__ + "static/media/life-before.737122bd.png";